import React from 'react';
import {Link as RouterLink, useLocation} from "react-router-dom";
import Link from '@mui/material/Link';
import ListItemButton from "@mui/material/ListItemButton";
import {ListItemIcon} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import CircleIcon from '@mui/icons-material/Circle';
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import { SIDEBAR_VIEWS } from "@jumbo/utils/constants/layout";
import { useTranslation } from "react-i18next";


const menuBefore = {
    left: 0,
    top: 0,
    content: `''`,
    position: 'absolute',
    display: 'inline-block',
    width: '4px',
    height: '100%',
    backgroundColor: 'transparent'
}

const JumboNavItem = ({item, isNested, translate}) => {
    const location = useLocation();
    const {sidebarOptions} = useJumboLayoutSidebar();
    const {t} = useTranslation();

    const isMiniAndClosed = React.useMemo(() => {
        return sidebarOptions?.view === SIDEBAR_VIEWS.MINI && !sidebarOptions?.open;
    }, [sidebarOptions.view, sidebarOptions.open]);

    const label = React.useMemo(() => {
        return translate ? t(item.label) : item.label;
    }, [item, translate, t]);

    if (!item) return null;

    const tenantName = localStorage.getItem("TENANT_NAME")==="Lathrop GPM";

    const isActive = React.useMemo(() => {
        if (!item?.uri) return false;
        if (location.pathname === item.uri) return true;
        if (location.pathname.startsWith(item.uri + "/")) return true;
        if (item.uri === "/collaboration-space/oa-workflow" && location.pathname.startsWith("/collaboration-space/oa-workflow/tasks")) return true;
        return false;
    }, [location.pathname, item.uri]);

    const handleNavClick = (event) => {
        const targetPath = item?.uri;
    const shouldIntercept = Boolean(typeof window !== "undefined" && window.__kotHasUnsavedChanges && targetPath && targetPath !== location.pathname);

        if (!shouldIntercept) return;

        event.preventDefault();
        window.dispatchEvent(new CustomEvent("kot-nav-request", { detail: { to: targetPath } }));
    };

    return (
        <ListItemButton
            component={"li"}
            sx={{
                p: 0,
                overflow: 'hidden',
                borderRadius: isMiniAndClosed ? '50%' : '0 24px 24px 0',
                margin: isMiniAndClosed ? '0 auto' : '0',
                
                ...(isMiniAndClosed) ? {width: 40, height: 40, justifyContent: 'center'} : {},
                ...(!isMiniAndClosed) ? {'&::before': menuBefore} : {},
                '&:hover': {
                    color: (tenantName && !item.uri) ? theme => theme.palette.nav.action.disabled :theme => theme.palette.nav.action.active,
                    backgroundColor: (tenantName && !item.uri) ? theme => theme.palette.nav.background.disabled: theme => theme.palette.nav.background.active,
                    ...(!isMiniAndClosed) ? {'&::before': {
                            ...menuBefore,
                            backgroundColor: (tenantName && !item.uri) ? theme => theme.palette.nav.tick.disabled :theme => theme.palette.nav.tick.active,
                        }} : {}
                },
                ...(isActive) ? {
                    color: theme => theme.palette.nav.action.active,
                    backgroundColor: theme => theme.palette.nav.background.active,
                    ...(!isMiniAndClosed) ? {'&::before': {
                        ...menuBefore,
                            backgroundColor: theme => theme.palette.nav.tick.active,
                    }}: {},
                } : {},
            }}
        >
            <Link underline={"none"} component={RouterLink} to={item.uri} {...(item.target ? {target: item.target} : {})}
                  onClick={handleNavClick}
                  sx={{
                    cursor: (tenantName && !item.uri) ? "default" : "pointer",
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      overflow: "hidden",
                      position: "relative",
                      color: (tenantName && !item.uri) ? "grey":'inherit',
                      p: theme => !isMiniAndClosed ? theme.spacing(1, 3.75) : 0,
                      ...(isMiniAndClosed) ? {justifyContent: 'center'} : {},
                  }}
            >
                <ListItemIcon sx={{minWidth: isMiniAndClosed ? 20 : 32, color: 'inherit'}}>
                    {
                        isNested ?
                            <CircleIcon sx={{fontSize: 6, ml: 1}}/>
                            :
                            item.icon
                    }
                </ListItemIcon>
                {
                    !isMiniAndClosed &&
                    <ListItemText
                        primary={label}
                       sx={{
                            m: 0,
                            '& .MuiTypography-root': {
                                whiteSpace: 'normal',     // ✅ allow wrapping
                                overflow: 'visible',      // ✅ let it expand
                                textOverflow: 'unset',    // ✅ remove ellipsis
                                wordBreak: 'break-word',  // ✅ prevent overflow issues
                            }
                        }}
                    />
                }
            </Link>
        </ListItemButton>
    );
};
export default JumboNavItem;
